import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const ContactUs = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Contact Us</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <p className="text-3">
                          For Customer Support and Query, Get in touch with us:
                        </p>
                        <div className="featured-box style-1">
                          <div className="featured-box-icon text-success">
                            <i className="fab fa-whatsapp" />
                          </div>
                          <h3>WhatsApp</h3>
                          <p className="text-3">
                            <a
                              href={`https://wa.me/${APP_INFO.whatsappNumberRedirect}?text=Hello, I have a question and need some help!`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {APP_INFO.whatsappNumber}
                            </a>
                          </p>

                          {/* Live Chat Button */}
                          <a
                            href={`https://wa.me/${APP_INFO.whatsappNumberRedirect}?text=Hello, I have a question and need some help!`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success btn-sm mb-3"
                          >
                            Chat with Us
                          </a>
                        </div>

                        <div className="featured-box style-1">
                          <div className="featured-box-icon text-primary">
                            <i className="fas fa-phone" />
                          </div>
                          <h3>Phone Number</h3>
                          <p className="text-3">{APP_INFO.phone}</p>
                        </div>
                        <div className="featured-box style-1">
                          <div className="featured-box-icon text-primary">
                            <i className="fas fa-envelope" />
                          </div>
                          <h3>Email Address</h3>
                          <p className="text-3">
                            <a href={`mailto:${APP_INFO.email}`}>
                              {" "}
                              {APP_INFO.email}{" "}
                            </a>
                          </p>
                        </div>

                        {/* Additional Support Info */}
                        <div className="mt-4">
                          <p>
                            <strong>Email Support:</strong> We reply within 24
                            hours. Rest assured, we will respond to all your
                            queries as soon as possible.
                          </p>
                          <p>
                            <strong>Phone Support:</strong> Available Monday to
                            Saturday from 10:00 AM to 7:00 PM. On Saturdays, we
                            close by 4:00 PM.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
